import { HealthStatus, PortfolioKpis, ProjectHealthUI } from "models/project-health"
import { ProjectUI } from "models/project"
import { formatCurrency, formatNumber } from "utils/tools"

interface PortfolioKpisRowProps {
    kpis: PortfolioKpis | null
    isLoading: boolean
}

const STATUS_ORDER = [HealthStatus.CRITICAL, HealthStatus.WARNING, HealthStatus.GOOD, HealthStatus.NOT_EVALUATED]

const PortfolioKpisRow = ({ kpis, isLoading }: PortfolioKpisRowProps) => {
    const pending = isLoading || !kpis

    return (
        <div className="health-kpis portfolio-kpis">
            <div className="kpi">
                <label>Revenue (LTD, filtered projects)</label>
                <strong>{pending ? "…" : formatCurrency(kpis.revenue, "CAD", 0)}</strong>
                <small>{pending ? "" : `${kpis.projectCount} project(s) · ${formatCurrency(kpis.accrued, "CAD", 0)} accrued`}</small>
            </div>
            <div className="kpi">
                <label>Gross Margin</label>
                <strong className={!pending && kpis.grossMarginPercent !== null
                    ? ProjectUI.marginPercentColor(kpis.grossMarginPercent, { minimumMargin: kpis.marginMinimum, warningMargin: kpis.marginWarning })
                    : undefined}>
                    {pending ? "…" : kpis.grossMarginPercent !== null ? `${formatNumber(kpis.grossMarginPercent, 1)}%` : "—"}
                </strong>
                <small>{pending ? "" : `Revenue-weighted · minimum ${kpis.marginMinimum}% (FY${kpis.marginTargetFiscalYear})`}</small>
            </div>
            <div className="kpi">
                <label>Total AR (&gt;60 days)</label>
                <strong>—</strong>
                <small>Available once invoices are synced from Acumatica</small>
            </div>
            <div className="kpi">
                <label>Health (Active projects)</label>
                <strong>{pending ? "…" : `${kpis.evaluatedProjects} evaluated`}</strong>
                <small>
                    {!pending && STATUS_ORDER.filter(s => kpis.statusCounts[s] > 0).map((s, i) => (
                        <span key={s} className={`text-${ProjectHealthUI.color(s)}`}>
                            {i > 0 && <span className="text-muted"> · </span>}
                            <i className={`${ProjectHealthUI.icon(s)} me-1`} />{kpis.statusCounts[s]} {ProjectHealthUI.label(s)}
                        </span>
                    ))}
                </small>
            </div>
        </div>
    )
}

export default PortfolioKpisRow
